<template>
  <div v-if="siteConfig.isQa == 1">
    <div class="question-wrap" v-show="questionList.length <= 0">
      <div class="question-empty">
        <!-- <img src="../../assets/images/v3/no-data.png" /> -->
        当前还没有提问
      </div>
    </div>
    <!-- 多个遍历 -->
     <div id="question-list"></div>
    <div
      class="question-list"
      v-for="(item, index) in questionList"
      :key="index"
    >
      <div class="question-info clearfix">
        <div class="question-info-img">
          <Avatar
            v-if="item.userPic"
            :src="concatImageUrl(item.userPic, 50, 50, true)"
            size="50"
          />
          <Avatar
            v-else
            :src="require('../../assets/images/v3/avatar-default.png')"
            size="50"
          />
        </div>
        <div class="question-info-user">
          <h4>
            <span>{{ item.qUserName }}</span>
            <span v-if="item.teacherType == 3" class="guide"></span>
            <div v-if="item.teacherType == 3" >
              <img src="../../assets/images/Transferred.png" alt="">
            </div>
          </h4>
          <p class="question-info-position">发自|{{ item.fromPosition }}</p>
        </div>
      </div>
      <div class="question-content">
        <div class="question-title" v-latex="item.qContent.replace(/(\\n)|\r?\n|\r/g, '<br/>')"></div>
        <ul class="question-image clearfix">
          <li v-if="item.qPic1">
            <a :href="concatImageUrl(item.qPic1, 0, 0, true)" target="_blank">
              <img
                :src="concatImageUrl(item.qPic1, 64, 64, true)"
                alt
                @click="imageView()"
              />
            </a>
          </li>
          <li v-if="item.qPic2">
            <a :href="concatImageUrl(item.qPic2, 0, 0, true)" target="_blank">
              <img
                :src="concatImageUrl(item.qPic2, 64, 64, true)"
                alt
                @click="imageView()"
              />
            </a>
          </li>
          <li v-if="item.qPic3">
            <a :href="concatImageUrl(item.qPic3, 0, 0, true)" target="_blank">
              <img
                :src="concatImageUrl(item.qPic3, 64, 64, true)"
                alt
                @click="imageView()"
              />
            </a>
          </li>
        </ul>
      </div>
      <div class="question-action">
        <span>{{ item.qTime }}</span>
        <a
          href="javascript:;"
          @click="saveGoods(item)"
          class="question-action-like"
        >
          <Icon custom="ich-icon ich-icon-like-fill" size="16" />
          <span>{{ item.goodNum }}</span>
        </a>
        <a href="javascript:;" title="回复数" class="question-action-comment">
          <Icon custom="ich-icon ich-icon-comment-fill" size="16" />
          <span>{{ item.comments.length }}</span>
        </a>
      </div>
      <!-- 总回复 -->
      <div class="question-reply">
        <input
          name="reply-content"
          v-model="item.replyContent"
          :placeholder="'回复@' + item.qUserName"
          maxlength="200"
        />
        <button type="button" @click="saveUserComment(item)">回 复</button>
      </div>
      <!-- 多个回答遍历 -->
      <div class="question-answer-wrapper">
        <div
          class="question-answer"
          v-for="(common, i) in item.comments.filter((m) => m.pId == 0)"
          :key="i"
        >
          <div class="question-answer-content clearfix teacher-box">
            <Avatar
              :src="concatImageUrl(common.userPic, 30, 30, true)"
              class="question-answer-avatar"
              size="30"
              v-if="common.userPic"
            />
            <Avatar
              v-else
              :src="require('../../assets/images/v3/avatar-default.png')"
              size="30"
            />
            <p>
              <span class="question-answer-name">{{ common.userName }}</span>
              <!-- 是教师时才显示 -->
              <Tag color="warning" v-show="common.isCommentByTeach">教师</Tag>
              <span class="question-answer-show" v-latex="common.commentContent.replace(/(\\n)|\r?\n|\r/g, '<br/>')"></span>
            </p>
            <p>
              <span class="time">{{ common.commentTime }}</span>
              <a
                href="javascript:;"
                title="点击回复"
                class="replay-action"
                :class="{ active: common.replyVisible }"
                @click="replyVisible(common)"
              >
                回复
              </a>
              <span v-if="item.teacherType == 2 && common.article1 && common.teacherType == 2" class="artificial" @click="changeArtificial(item)">
                <img src="../../assets/images/artificial.png" alt="">
                <span>转人工</span>
              </span>
            </p>
          </div>
          <!-- 教师回答展示图片 -->
          <ul
            class="question-answer-image clearfix"
            v-show="common.isCommentByTeach && common.commentPic1"
          >
            <li v-show="common.commentPic1">
              <a
                :href="concatImageUrl(common.commentPic1, 0, 0, true)"
                target="_blank"
              >
                <img
                  alt="answer"
                  :src="concatImageUrl(common.commentPic1, 60, 60, true)"
                />
              </a>
            </li>
            <li v-show="common.commentPic2">
              <a
                :href="concatImageUrl(common.commentPic2, 0, 0, true)"
                target="_blank"
              >
                <img
                  alt="answer"
                  :src="concatImageUrl(common.commentPic2, 60, 60, true)"
                />
              </a>
            </li>
            <li v-show="common.commentPic3">
              <a
                :href="concatImageUrl(common.commentPic3, 0, 0, true)"
                target="_blank"
              >
                <img
                  alt="answer"
                  :src="concatImageUrl(common.commentPic3, 60, 60, true)"
                />
              </a>
            </li>
          </ul>
          <div class="comment-reply" v-show="common.replyVisible">
            <input
              name="reply-content"
              v-model="common.replyContent"
              maxlength="500"
              :placeholder="'回复@' + common.userName"
            />
            <button type="button" @click="saveUserReply(common)">回 复</button>
          </div>
          <!-- 回复列表 -->
          <div
            class="question-answer-reply"
            v-show="
              item.comments.filter((m) => m.pId == common.commentId).length > 0
            "
          >
            <div
              class="question-answer-content"
              v-for="(reply, ri) in item.comments.filter(
                (m) => m.pId == common.commentId
              )"
              :key="ri"
            >
              <Avatar
                :src="concatImageUrl(reply.userPic, 30, 30, true)"
                class="question-answer-avatar"
                size="30"
                v-if="reply.userPic"
              />
              <Avatar
                v-else
                :src="require('../../assets/images/v3/avatar-default.png')"
                size="30"
              />
              <p>
                <span class="color2" style="margin-right: 8px">{{
                  reply.userName
                }}</span>
                回复
                <span
                  class="color2"
                  style="margin-left: 8px; margin-right: 8px"
                  >{{ reply.pName }}</span
                >
                <span v-latex="reply.commentContent.replace(/(\\n)|\r?\n|\r/g, '<br/>')"></span>
              </p>
              <p>
                <span class="time">{{ reply.commentTime }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { study } from "../../request";
export default {
  mixins: [siteMixin],
  props: {
    questionType: {
      type: String,
      default: "ppt",
    },
    // questionList: {
    //   type: Array,
    //   default() {
    //     return [];
    //   }
    // }
  },
  data() {
    return {
      questionList: [],
    };
  },
  watch: {
    pptId() {
      this.getData();
    },
    exerId() {
      this.getData();
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.pptId > 0 && this.questionType == "ppt") {
        study
          .getVideoQuestionList(this.loginUser.userId, this.pptId)
          .then((res) => {
            //console.log("questionList-ppt", res);
            if (res.status === 1) {
              this.questionList = res.data;
              this.questionList.forEach((item) => {
                this.$set(item, "replyContent", "");
                item.comments.forEach((common) => {
                  this.$set(common, "replyVisible", false);
                  this.$set(common, "replyContent", "");
                });
              });
              this.$emit("on-loadFinish", this.questionList);
            }
          });
      } else if (this.exerId > 0) {
        study
          .getExerciseQuestionList(this.loginUser.userId, this.exerId)
          .then((res) => {
            //console.log("questionList-exercise", res);
            if (res.status === 1) {
              this.questionList = res.data;
              this.questionList.forEach((item) => {
                this.$set(item, "replyContent", "");
                let lastA1Index = null;
                item.comments.forEach((common,commonIndex) => {
                  this.$set(common, "replyVisible", false);
                  this.$set(common, "replyContent", "");
                  // 转人工只有第一条
                  if (!lastA1Index && common.isCommentByTeach ) {
                    common.article1 = true
                    lastA1Index = true;
                  }
                });
              });
              this.$emit("on-loadFinish", this.questionList);
            }
          });
      }
    },
    saveGoods(item) {
      study.saveUserGoods(item.qId, this.loginUser.userId).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          item.goodNum++;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    saveUserComment(item) {
      let data = {
        UserId: this.loginUser.userId,
        PName: "",
        PId: 0,
        UmcId: item.umcId,
        QId: item.qId,
        FromPosition: item.fromPosition,
        CommentContent: item.replyContent,
        IsCommentByTeach: false,
        CommentPic1: "",
        CommentPic2: "",
        CommentPic3: "",
      };
      // 判断是否为人工或已转人工
      if (item.teacherType == 1 || item.teacherType == 3) {
        data.teacherType = 1;
      }
      study.saveUserComment(data).then((res) => {
        console.log("saveComment", res);
        if (res.status === 1) {
          this.$Message.success("发表成功");
          this.getData();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    saveUserReply(item) {
      let data = {
        UserId: this.loginUser.userId,
        PName: item.userName,
        PId: item.commentId,
        UmcId: item.umcId,
        QId: item.qId,
        FromPosition: item.fromPosition,
        CommentContent: item.replyContent,
        IsCommentByTeach: false,
      };
      study.saveUserComment(data).then((res) => {
        if (res.status === 1) {
          this.$Message.success("回复成功");
          this.getData();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    replyVisible(item) {
      item.replyVisible = !item.replyVisible;
    },
    imageView() {},
    // 转人工 采用新增接口
    changeArtificial(item) {
      // window.scrollTo({
      //   top: 300,
      //   behavior: 'smooth'
      // });
      //提交数据
      study
        .saveUserQuestion({
          UserId: item.userId,
          ExerId: item.exerId,
          UmcId: item.umcId,
          PptId: item.pptId,
          FromPosition: item.fromPosition,
          QContent: item.qContent,
          souQid:item.qId,
          picfilename1: item.qPic1,
          picfilename2: item.qPic2,
          picfilename3: item.qPic3,
          teacherType:3,// 1为人工 2为AI 3为转人工
        })
        .then((res) => {
          if (res.status === 1) {
            this.$Message.success("已转人工老师，稍后解答");
            this.$emit("on-success");
            this.getData();
          } else {
            this.$Message.error(res.message);
          }
        });
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/question.less";
</style>